import './BlockContent.css';
import React from 'react';

function BlockContent(props) {
 
  const blockstyle = {
    //width: window.innerWidth > 767 ? props.width : "90%",
    // width: "500px",
    textAlign: props.textAlign ? props.textAlign : "start",
    fontStyle: props.fontStyle ? props.fontStyle : "normal",
  };

  return (
    <div id="BlockContent" style={blockstyle}>
    {/* <div id="BlockContent"> */}
      {props.children}
      {/* {updatedChildren} */}
    </div>

  );
}

export default BlockContent;
